import React, { useEffect, useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import { Navbar } from 'Pages/LandingPage/Components';
import { FadeOnScroll } from 'Pages/LandingPage/Components/FadeOnScroll';
import { ScrollUpBtn } from 'Components/ScrollUpBtn';
import { Footer } from 'Pages/LandingPage/HomeSection/sections/Footer';
import patternedBackground from 'Assets/svg/patternedBackground.svg';
import { NavbarBusiness } from 'Pages/LoopForBusiness/Components/NavbarBusiness';
import useLocalizedNavigate from 'Utils/useLocalizedNavigate';
import { AppRoutes } from 'Routes/AppRoutes';
export interface ILandingPageLayoutChild {
  shouldIgnoreParentPadding?: boolean;
}

interface ILandingPageLayoutProps {
  JumbotronSection: React.ReactNode;
  children: React.ReactNode;
  disableGradientBackground?: boolean;
  linkColorMode?: 'light' | 'black';
  paddingTop?: string;
  isBusiness?: boolean;
}

export const LandingPageLayout = ({
	JumbotronSection,
	children,
	linkColorMode,
	isBusiness
}: ILandingPageLayoutProps) => {
	const navigate = useLocalizedNavigate();
	const [isVisible, setIsVisible] = useState(true);

	const handleSwitch = (toBusiness: boolean) => {
		navigate(toBusiness ? AppRoutes.LoopForBusiness : AppRoutes.landingpage);
	};

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 100) {
				setIsVisible(false);
			} else {
				setIsVisible(true);
			}
		};
	
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<Box overflowX="hidden">
			<Box
				position="fixed"
				top="0"
				zIndex="1000"
				bg="#264653"
				borderBottom={'1px solid'}
				borderColor={'white'}
				opacity={isVisible ? 1 : 0}
				transition="opacity 0.3s ease-in-out"
				pointerEvents={isVisible ? 'auto' : 'none'}
				display={['none', null, null, 'block']}
				w={'100%'}
				h={'40px'}
			>
				<Flex>
					<Button fontFamily={'Futura'} onClick={() => handleSwitch(false)} borderRight={'1.5px solid'} 
						borderColor={'darkCoral'} borderRadius={'none'} w={'150px'} 
						h={'39px'}  bg={isBusiness ? '#264653' : 'darkCoral'} 
						fontWeight={isBusiness ? 'bold' : 'bold'} color={ isBusiness ? 'white' : 'white'} 
						fontSize={'14px'} textTransform={'uppercase'} >
							Loop
					</Button>
					<Button fontFamily={'Futura'}  onClick={() => handleSwitch(true)} borderRight={'1.5px solid'} 
						borderColor={'darkCoral'} w={'180px'} h={'39px'} borderRadius={'none'} 
						bg={isBusiness ? 'darkCoral' : '#264653'}  fontWeight={isBusiness ? 'bold' : 'bold'} 
						color={ isBusiness ? 'white' : 'white'} fontSize={'14px'}
						textTransform={'uppercase'}
					>
						Loop For Business
					</Button>
				</Flex>
			</Box>
			<Box
				py="8"
				mt={['0','35px']}
				px={['5', '20',]}
				bg= {'linear-gradient(180deg, rgba(255, 111, 97, 0.18) -97.87%, rgba(255, 111, 97, 0.00) 100%)'}
				bgImage={`url(${patternedBackground})`}
				bgPosition="center"
				bgRepeat="no-repeat"
				bgSize="cover"
			>
				{isBusiness ? <NavbarBusiness /> : <Navbar linkColorMode={linkColorMode} />}
				<Box maxW={'1440px'}  minH={['400px', null, null,null,'50vh', '50vh']} m={'0 auto'}>{JumbotronSection}</Box>
			</Box>

			{React.Children.map(children, (child) => {
				if (React.isValidElement(child)) {
					if (child.props.shouldIgnoreParentPadding) {
						return (
							<Box  maxW={'2560px'} m={'0 auto'} mb={child.props?.isCTA ? '0' : ['50px', '100px']} >
								<FadeOnScroll>{child}</FadeOnScroll>
							</Box>
						);
					}

					return (
						<Box maxW={'2560px'} m={'0 auto'} mb={['50px', null, null, null, '100px', null]} px={{base: '30px', xl: '80px', '2xl': '192px' }}>
							<FadeOnScroll>{child}</FadeOnScroll>
						</Box>
					);
				}
				return child;
			})}

			<Footer isBusiness={isBusiness} />
			<ScrollUpBtn />
		</Box>
	);
};
